import FrmWorkerRecords from '@/pages/presence/workerRecords/FrmWorkerRecords.vue';
import FrmWorkersActivity from '@/pages/presence/workerRecords/FrmWorkersActivity.vue';
import FrmNewWorkerRecord from '@/pages/presence/workerRecords/FrmNewWorkerRecord.vue';
import FrmWorkerRecordsSearch from '@/pages/presence/workerRecords/FrmWorkerRecordsSearch.vue';
// import FrmNewMassiveRecords from '@/pages/presence/workerRecords/FrmNewMassiveRecords.vue';
import FrmMassiveRecordsNew from '@/pages/presence/workerRecords/FrmMassiveRecordsNew.vue';

export default [
  {
    path: '/presence/workerRecords/workerRecords',
    component: FrmWorkerRecords,
    props: true,
  },
  {
    path: '/production/workerRecords/workersActivity',
    component: FrmWorkersActivity,
  },
  {
    path: '/production/workerRecords/newWorkerRecord',
    component: FrmNewWorkerRecord,
  },
  // {
  //   path: '/presence/workerRecords/newMassiveRecords',
  //   component: FrmNewMassiveRecords,
  // },
  {
    path: '/presence/workerRecords/newMassiveRecords',
    component: FrmMassiveRecordsNew,
  },
  {
    path: '/presence/workerRecords/workerRecordsSearch',
    component: FrmWorkerRecordsSearch,
  },
];
